import { Storage } from '@/modules/plugins/storage'

const state = {
    expenseRules: [],
    expenseRulesLoaded: false,
    allowance: Storage.getItem('allowance'),
}

const mutations = {
    SET_EXPENSE_RULES(state, data) {
        state.expenseRules = data
    },
    EXPENSE_RULES_LOADED(state) {
        state.expenseRulesLoaded = true
    },
    SET_ALLOWANCE(state, data) {
        state.allowance = data
    },
}

const actions = {
    setExpenseRules({ commit }, data) {
        commit('SET_EXPENSE_RULES', data)
    },
    expenseRulesLoaded({ commit }) {
        commit('EXPENSE_RULES_LOADED')
    },
    setAllowance({ commit, state }, data) {
        commit('SET_ALLOWANCE', data)
        Storage.setItem('allowance', state.allowance)
    },
    resetAllowance({ commit }) {
        commit('SET_ALLOWANCE', null)
        Storage.removeItem('allowance')
    },
}

const getters = {
    expenseRules: (state) => state.expenseRules,
    expenseRulesLoaded: (state) => state.expenseRulesLoaded,
    allowance: (state, getters, rootState, rootGetters) =>
        rootGetters['site/checkoutView'] ? state.allowance : undefined,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
